<template>
<div id="wrap">
    <div class="reg-logo"><img src="~@/assets/images/logo.svg"></div>

    <div class="login-1">
        Greed Greed へようこそ<br>
        通話からはじまる<br>
        高品質な出会いをお楽しみください<br>
    </div>
    <div class="cp_iptxt">
        <input type="text" pattern="[0-9]*" inputmode="numeric" v-model="phone" id="phone" @keyup="checkLogin()" placeholder="携帯電話番号" maxlength="11" autocomplete="off">
        <i class="fas fa-mobile-alt fa-lg fa-fw" aria-hidden="true"></i>
    </div>
    <div class="cp_iptxt">
        <input type="password" id="password" v-model="password" @keyup="checkLogin()" placeholder="パスワード ※半角英数字8文字以上">
        <i class="fas fa-key fa-lg fa-fw" aria-hidden="true"></i>
    </div>
    <div class="reg1-4 mycheckbox"><input id="remember_me" value="1" type="checkbox" checked><label for="remember_me"></label>ID・パスワードを保存して自動ログイン</div>
    <div class="btn1" id='btn_login'><a @click="doLogin()">ログイン</a></div>
    <div class="login-2"><a style="text-decoration-line: underline;" @click="$router.push({name: 'resetPassword'})">ログインにお困りですか？</a></div>
    <div class="login-3">アカウントをお持ちでない場合<a style="text-decoration-line: underline;" @click="goToRegister()">登録はこちら</a></div>
</div>
<alertDialog :active="isAlert" @close="closeAlert()">
    <div>{{ alertMessage}}</div>
</alertDialog>
<div class="loading-screen" style="opacity: 0.6" v-if="isLoading">
    <div class="loader"></div>
</div>

<a id="p-ber-click" href="" onclick="wdlogin.init(this); return false;"></a>

</template>

<script>
import Cookies from 'js-cookie'
import CONSTANTS from '@/constants'
import alertDialog from '@/views/components/alertDialog'
import {
    getToken,
    setVerifyPhone,
    setStepRegister
} from '@/auth'
// import {
//     setRememberMe,
//     setToken,
//     setDeviceId,
// } from '@/auth'
import {
    mapGetters,
    mapActions
} from 'vuex'
import mixin from '@/mixin'
export default {
    mixins: [mixin],
    components: {
        alertDialog
    },
    data: () => ({
        isAlert: false,
        alertMessage: null,
        phone: null,
        password: null,
        isLoading: false
    }),
    mounted() {
        // Setup for p-ber Start
        let script = document.createElement("script");
        script.src = 'https://www.gstatic.com/firebasejs/7.16.1/firebase-app.js';
        document.head.appendChild(script);

        script = document.createElement("script");
        script.src = 'https://www.gstatic.com/firebasejs/7.16.1/firebase-messaging.js';
        document.head.appendChild(script);

        script = document.createElement("script");
        script.type = 'text/javascript';
        script.src = CONSTANTS.PUSH_SYS_URL + 'wdlogin.js';
        document.head.appendChild(script);

        script = document.createElement("script");
        script.innerHTML = 'var WD_CONFIG = { app_code: "' + CONSTANTS.PUSH_APP_CODE + '", app_key: "' + CONSTANTS.PUSH_APP_KEY + '" };';
        document.head.appendChild(script);
        // Setup for p-ber End

        this.checkLogin();

        setTimeout(() => {
            window.scrollTo(0, 0)
        }, 10)
    },
    computed: {
        ...mapGetters(["defaultToken", "userDetail"]),
    },
    methods: {
        ...mapActions({
            userProfile: 'user/userProfile',
        }),
        async doLogin() {
            if (!this.checkLogin()) {
                return false;
            }

            this.isLoading = true
            this.$store.dispatch("route/showLoading")

            // let phone = document.getElementById('phone').value
            // let password = document.getElementById('password').value
            let formData = new FormData()
            formData.append('phone', this.phone)
            formData.append('password', this.password)
            await this.$store.dispatch('login/doLogin', formData).then(async data => {
                let expire_day = 0;
                if (document.getElementById('remember_me').checked) {
                    expire_day = CONSTANTS.COOKIE_EXPIRE_DAY;
                }

                data.expire_day = expire_day;

                await this.$store.dispatch('login/setLoginCookie', data)
                await this.userProfile({
                    token: this.defaultToken
                })

                const userAgent = navigator.userAgent;
                if (parseInt(this.userDetail.is_verify_phone) !== CONSTANTS.VERIFY_PHONE_NUMBER_SUCCESS) {
                    setStepRegister(CONSTANTS.STEP_REGISTER_UPDATE_INFO)
                    this.$router.push({
                        name: 'register'
                    })

                } else if (this.checkUpdateProfile()) {
                    setStepRegister(CONSTANTS.STEP_REGISTER_UPDATE_INFO)
                    setVerifyPhone()
                    this.$router.push({
                        name: 'register'
                    })

                } else if (userAgent.includes("iPhone") || userAgent.includes("iPad")) {
                    document.getElementById('p-ber-click').setAttribute('data-user-id', data.id);
                    document.getElementById('p-ber-click').click()

                } else {
                    // Redirect
                    let redirect_url = window.location.search;
                    if (redirect_url != '') {
                        this.$router.push(redirect_url.replace('?', ''))

                    } else {
                        this.$router.push({
                            name: 'home'
                        })
                    }

                    setTimeout(() => {
                        this.$router.go()
                    }, 100)
                }

                // await this.$store.dispatch('socket/initState');
                // await this.$store.dispatch('socket/setupSocketCallEvent');
            }).catch(err => {
                console.log(err);
                this.isAlert = true;
                this.$store.dispatch("route/hideLoading")
                this.alertMessage = CONSTANTS.LOGIN_FAIL_ALERT
            })
            
            this.isLoading = false
        },
        closeAlert() {
            this.isAlert = false
        },

        checkLogin() {
            if (this.phone) {
                this.phone = this.phone.replace(/\D/g,'');
            }
            if (this.phone && this.password && this.phone.length === 11) {
                // document.getElementById('btn_login').disabled = false;
                document.getElementById('btn_login').style = CONSTANTS.COMMON_BUTTON_ENABLE;
                return true;

            } else {
                document.getElementById('btn_login').style = CONSTANTS.COMMON_BUTTON_DISABLE;
                return false;
            }
        },


        goToRegister() {
            this.$router.push({
                name: 'register',
                query: {
                    is_main: 1
                }
            })
        },

        checkUpdateProfile() {
            if (this.userDetail.sex == CONSTANTS.MALE && 
                (
                    !this.userDetail.job ||
                    !this.userDetail.mood_status ||
                    !this.userDetail.user_status
                )
            ) {
                return true

            } else if (this.userDetail.sex == CONSTANTS.FEMALE &&
                (
                    !this.userDetail.height ||
                    !this.userDetail.style ||
                    !this.userDetail.mood_status ||
                    !this.userDetail.user_status
                )
            ) {
                return true
            }

            return false
        },

    },
}
</script>
<style scoped>
    .reg1-4.mycheckbox label {
        padding-left: 0px;
        margin-right: 28px;
    }
</style>